module.exports = __webpack_public_path__ + "static/media/Inter-Regular.4f147571.woff";